module.exports = __webpack_public_path__ + "img/EMS.12d74f12.png";